module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Gerar Novo Lote',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Empresa",
      "placeholder": "Pesquisar empresa",
      "items": _vm.config.list.id_emp,
      "loading": _vm.config.loading.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Layout",
      "placeholder": "Pesquisar layout",
      "items": _vm.config.list.layout,
      "loading": _vm.config.loading.layout,
      "itemText": "esocial",
      "is-object": "",
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getLayout
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "\n            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\n            pt-3\n            text-left\n          "
  }, [_c('b', [_vm._v("Aplicar outros filtros")])]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.config.list.id_fdt,
      "loading": _vm.config.loading.id_fdt,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "itemText": "fdt",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.fdts),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fdts", $$v)
      },
      expression: "formData.fdts"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Funcionário",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios", $$v)
      },
      expression: "formData.funcionarios"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de cadastro do arquivo",
      "type": "daterange",
      "disabled": !_vm.formData.id_emp ||
        !_vm.formData.layout
    },
    model: {
      value: (_vm.formData.created_at),
      callback: function($$v) {
        _vm.$set(_vm.formData, "created_at", $$v)
      },
      expression: "formData.created_at"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Não incluir os seguintes funcionários",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios_delete),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios_delete", $$v)
      },
      expression: "formData.funcionarios_delete"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Somente eventos avulsos",
      "items": [{
        id: 1,
        nome: 'Sim'
      }, {
        id: 0,
        nome: 'Não'
      }],
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.avulso),
      callback: function($$v) {
        _vm.$set(_vm.formData, "avulso", $$v)
      },
      expression: "formData.avulso"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b3d88f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/gerar.vue
// module id = 1357
// module chunks = 44